import React from "react";
import PropTypes from "prop-types";
import TimeFormatter from "../../utils/TimeFormatter";
import classnames from "classnames";

const INDEX_OFFSET = -1;
const SCROLL_TOP_OFFSET = -5; // px

// eslint-disable-next-line react/display-name
const TranscriptRecord = React.forwardRef(({ begin, text }, ref) => {
    return (
        <li ref={ref} className="transcript__record">
            <span className="transcript__begin">
                {TimeFormatter.getPaddedDurationFromMilliSeconds(begin * 1000)}
            </span>
            <span className="transcript__text">{text}</span>
        </li>
    );
});

class Transcript extends React.Component {
    constructor(props) {
        super(props);

        this._previousIndex = 0;
        this._refs = [];
        this._containerRef = React.createRef();
    }

    render() {
        const {
            title,
            records,
            isTranscriptOn,
            isTranscriptReady,
            onClose,
            onOpen,
        } = this.props;
        this._refs = [];

        return (
            <div
                className={classnames("transcript", {
                    "transcript--shown": isTranscriptOn,
                    "transcript--ready": isTranscriptReady,
                })}
            >
                <div className="transcript__header">
                    <h2 className="transcript__title">{title}</h2>
                    <button className="transcript__open" onClick={onOpen}>
                        Open
                    </button>
                    <button className="transcript__close" onClick={onClose}>
                        Close
                    </button>
                </div>
                <div ref={this._containerRef} className="transcript__content">
                    <ul
                        className="transcript__container"
                        tabIndex={isTranscriptOn ? "0" : "-1"}
                    >
                        {records.map(({ begin, text }, index) => {
                            const ref = React.createRef();
                            this._refs.push(ref);
                            return (
                                <TranscriptRecord
                                    key={index}
                                    {...{ begin, text, ref }}
                                />
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }

    componentDidUpdate(prevProps) {
        this._setScrollPosition(prevProps);
    }

    _setScrollPosition(prevProps) {
        const isTranscriptContentTheSame =
            prevProps.records === this.props.records;
        if (
            !this.props.isTranscriptOn ||
            (isTranscriptContentTheSame &&
                prevProps.playerTime === this.props.playerTime)
        ) {
            return;
        }

        const newIndex = this._getCurrentIndex();
        if (newIndex === this._previousIndex && isTranscriptContentTheSame) {
            return;
        }

        this._previousIndex = newIndex;
        this._scrollTo(newIndex);
    }

    _scrollTo(index) {
        const topEl = this._refs[index].current;
        this._containerRef.current.scrollTop =
            topEl.offsetTop + SCROLL_TOP_OFFSET;
    }

    _getCurrentIndex() {
        const { records, playerTime } = this.props;

        for (let index = 0; index < records.length; index++) {
            if (records[index].begin > playerTime) {
                return Math.max(index - 1 + INDEX_OFFSET, 0);
            }
        }

        return records.length - 1 + INDEX_OFFSET;
    }
}

Transcript.defaultProps = {
    records: [],
    playerTime: 0,
};

Transcript.propTypes = {
    title: PropTypes.string.isRequired,
    records: PropTypes.arrayOf(
        PropTypes.shape({
            begin: PropTypes.number.isRequired,
            text: PropTypes.string.isRequired,
        })
    ),
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    isTranscriptOn: PropTypes.bool,
    isTranscriptReady: PropTypes.bool,
    playerTime: PropTypes.number,
};

export default Transcript;
